import React from "react";
import { Button, CircularProgress } from "@material-ui/core";
import { AppButtonProps } from "./app-button.types";

const AppButtonComponent: React.FC<AppButtonProps> = ({
  children,
  loading = false,
  disabled,
  variant = "contained",
  color = "primary",
  ...props
}) => {
  return (
    <Button
      variant={variant}
      color={color}
      disabled={loading || disabled}
      {...props}
    >
      {loading ? <CircularProgress size={20} color="inherit" /> : children}
    </Button>
  );
};

export default AppButtonComponent;
